import { Col, Row } from "antd";
import React, { useEffect } from "react";
import Authbg from "../../Assets/Images/auth-img.png";
import cytologo from "../../Assets/logo/Doxzon Logo.svg";
import webIcon from "../../Assets/Images/webicon.jpg";

const AuthLayout = ({ children }) => {

  return (
    <div
      className="h-screen"
      style={{ backgroundSize: "cover", backgroundPosition: "full" }}
    >
      <div>
        <div className="min-h-screen flex flex-col justify-center items-center w-screen h-screen">
          <div
            className="md:w-[35%] w-[80%] flex flex-col justify-center items-center shadow-2xl border rounded-md"
            style={{ margin: "0 auto" }}
          >
            <div className="mt-4 flex flex-col gap-1 justify-center items-center ">
              <img src={cytologo} alt="logo" className="w-32 h-10" />
              <span className="text-[12px]">Technology for Health</span>
            </div>
            <div className="text-center mt-2 text-xl text-[#189FAA] font-semibold ">
              Doctor
            </div>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
